import React, { PropsWithChildren } from "react";
//#region types
import { DialogEnums } from "models/enums";
import { EntityFullScreenProps } from "models/propTypes/pageLayoutPropTypes";
//#endregion
//#region components
import useNavigationHistory from "../useNavigationHistory";
import DialogContainer from "../dialogs/dialogContainer";
import TableItemNavigation from "../tables/tableItemNavigation";
import { ErrorView } from "components/error";
//#endregion

const EntityFullScreen: React.FC<PropsWithChildren<EntityFullScreenProps>> = (props) => {
  const {
    entityKey,
    hasPermissions,
    hideCloseButton,
    headerCustomContent,
    className,
    navigation,
    hideSpeedDial: hideSupportButton,
    confirmCloseOnX,
  } = props;

  const { goBack } = useNavigationHistory();

  return hasPermissions === false ? (
    <ErrorView />
  ) : (
    <DialogContainer
      key={`${entityKey}`}
      isOpen={true}
      title={navigation ?? ""}
      dialogType={hideSupportButton ? DialogEnums.DialogType.FullScreenNoSpeedDial : DialogEnums.DialogType.FullScreen}
      closeDialog={props.closeDialog ?? goBack}
      headerCustomContent={headerCustomContent ?? <TableItemNavigation />}
      hideCloseButton={hideCloseButton}
      className={className}
      confirmCloseOnX={confirmCloseOnX}
    >
      {props.children}
    </DialogContainer>
  );
};

export default EntityFullScreen;
